import { COUNTRY_NAME_TO_ALPHA3 } from "./country-name-to-alpha3";
import { STATE_NAME_TO_ALPHA2 } from "./state-name-to-alpha2";

function toAlpha3(country?: string | null): string | undefined {
  if (!country) return undefined;

  const c = country.trim().toLowerCase();

  if (/^[A-Za-z]{3}$/i.test(c)) return c.toUpperCase();

  return COUNTRY_NAME_TO_ALPHA3[c];
}

export function formatLocationDisplay(
  loc?: {
    city?: string | null;
    state?: string | null;
    country?: string | null;
  } | null,
) {
  if (!loc) return "";

  const city = loc.city?.trim() || "";
  const state = loc.state?.trim() || "";
  const country = loc.country?.trim() || "";

  if (!city && !state && !country) return "";

  const countryLower = country.toLowerCase();

  const isUS =
    countryLower === "us" ||
    countryLower === "usa" ||
    countryLower === "united states" ||
    countryLower === "united states of america";

  // US formatting
  if (isUS) {
    const stateAbbrev =
      STATE_NAME_TO_ALPHA2[state.toLowerCase()] || state.toUpperCase();

    if (city && stateAbbrev) return `${city}, ${stateAbbrev}`;
    if (city) return city;
    return stateAbbrev;
  }

  // International formatting
  const alpha3 = toAlpha3(country);

  if (city && alpha3) return `${city}, ${alpha3}`;
  if (city) return city;

  // Fallback to full country name
  return alpha3 ?? country;
}
